import { render, staticRenderFns } from "./BootstrapSlider.vue?vue&type=template&id=7b895f84&scoped=true&"
import script from "./BootstrapSlider.vue?vue&type=script&lang=js&"
export * from "./BootstrapSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b895f84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Data\\TeamCity\\buildAgent\\work\\6dffdb6616650f37\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b895f84')) {
      api.createRecord('7b895f84', component.options)
    } else {
      api.reload('7b895f84', component.options)
    }
    module.hot.accept("./BootstrapSlider.vue?vue&type=template&id=7b895f84&scoped=true&", function () {
      api.rerender('7b895f84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Components/Util/BootstrapSlider.vue"
export default component.exports